import { FC, ReactNode } from "react";
import {
  Flex,
  FormControl,
  FormLabel,
  Checkbox as ChakraCheckbox,
  FormErrorMessage,
  CheckboxProps,
} from "@chakra-ui/react";
import { useField } from "formik";
import { Check } from "~/icons";

interface Props extends CheckboxProps {
  id?: string;
  children: ReactNode;
  name?: string;
}

export const Checkbox: FC<Props> = ({ children, ...props }) => {
  const [field, meta] = useField({
    ...(props as any),
    type: "checkbox",
  });

  return (
    <FormControl isInvalid={meta.touched && !!meta.error}>
      <Flex align="flex-start">
        <ChakraCheckbox
          icon={<Check h={4} w={4} />}
          mr={2}
          mt={1}
          size="lg"
          variant="th-checkbox"
          isChecked={field.value}
          {...field}
          {...props}
        />
        <FormLabel htmlFor={props.id || props.name} m="0">
          {children}
        </FormLabel>
      </Flex>
      <Flex>
        <FormErrorMessage>{meta.error}</FormErrorMessage>
      </Flex>
    </FormControl>
  );
};
